/* unplugin-vue-components disabled */import DatePicker from 'primevue/datepicker'

const __default__ = {
  mixins: [ModelValue()],
  props: {
    placeholder: {  
      type: String,
      default: 'Select dates'
    },
    selectionMode: {
      type: String,
      default: 'range'
    },
    inline: {
      type: Boolean,
      default: false
    },
    maxDate: {
      type: Date,
      default: undefined
    },
    minDate: {
      type: Date,
      default: undefined
    }
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'calendar',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { get DatePicker() { return DatePicker } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})